import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'app-dynamic-form-intro',
	imports: [TranslatePipe],
	templateUrl: './dynamic-form-intro.component.html',
	styleUrl: './dynamic-form-intro.component.scss',
})
export class DynamicFormIntroComponent {}
